import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link} from 'react-router-dom'
import InfoView from 'components/InfoView';
import '../styles/root.css'
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import validateInput from '../validations/login/UpdatePassword';
import { userUpdatePasswrd,setZeroMessageRP } from 'actions';
import Alert from '@material-ui/lab/Alert';
import {isEmpty,isUndefined} from 'lodash'
import jwtDecode from 'jwt-decode';
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth}) {
    return {
        authUser: auth.authUser,
        token: auth.token,
        updateMessage: auth.updateMessage,
        success: auth.success
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setZeroMessageRP: () => dispatch(setZeroMessageRP()), 
        userUpdatePasswrd: (PassWordI) => dispatch(userUpdatePasswrd(PassWordI)), 
    };
}

class NyttPassword extends Component {
    constructor() {
        super();
        this.state = {
          email: '',
          Orgnr: '',
          password: '',
          Message: '',
          ShowMessage: false,
          errors:{},
          isLoading:false
        }
      }
      componentDidMount=()=>{
        this.props.setZeroMessageRP();
        if (this.props.token !== null) {
            console.log("asd")
         //  this.props.history.push('/');
        }else{
            console.log("asd2")
        }
    }
    isValid =()=>{
        let {Token}  = this.props.match.params;
        let user = jwtDecode(Token)
        const {errors, isValid} = validateInput(this.state,user.user_Email);
        if(!isValid){
         this.setState({errors:{
            ...this.state.errors,
            email:errors.email
        }})
       }
       console.log(isValid,"DDDA")
       console.log(errors,"DDDA")
       return isValid;
    }
    CheckPassword=()=>{
       // this.props.checkPassWord(this.state.user, this.props.authUser.user_id,this.state.password)
        console.log(this.state.password,"DDDDDA")
        const uppercaseRegExp   = /(?=.*?[A-Z])/;
        const lowercaseRegExp   = /(?=.*?[a-z])/;
        const digitsRegExp      = /(?=.*?[0-9])/;
        const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
        const minLengthRegExp   = /.{8,}/;
        const passwordLength =      isUndefined(this.state.password)?0:this.state.password.length;
        const uppercasePassword =   isUndefined(this.state.password)?false:uppercaseRegExp.test(this.state.password);
        const lowercasePassword =   isUndefined(this.state.password)?false:lowercaseRegExp.test(this.state.password);
        const digitsPassword =      isUndefined(this.state.password)?false:digitsRegExp.test(this.state.password);
        const minLengthPassword =   isUndefined(this.state.password)?false:minLengthRegExp.test(this.state.password);
        const specialCharPassword =   isUndefined(this.state.password)?false:specialCharRegExp.test(this.state.password);
    
        let Error=<>
        {(passwordLength === 0 || !minLengthPassword)?<div style={{fontSize:10}}>
        <IntlMessages id="Account.New.Password.Error.length" />
        </div>:""}
        {!uppercasePassword?<div style={{fontSize:10}}>
        <IntlMessages id="Account.New.Password.Error.UpperCase" />
        </div>:""}
        {!lowercasePassword?<div style={{fontSize:10}}>
        <IntlMessages id="Account.New.Password.Error.LowerCase" />
        </div>:""}
        {!digitsPassword?<div style={{fontSize:10}}>
        <IntlMessages id="Account.New.Password.Error.Num" />
        </div>:""}
        {!specialCharPassword?<div style={{fontSize:10}}>
        <IntlMessages id="Account.New.Password.Error.Special" />
        </div>:""}
        </>
        console.log(Error,"DDDDDA")
        let isNot = (passwordLength === 0 || !minLengthPassword || !uppercasePassword || !lowercasePassword 
          ||!digitsPassword ||!specialCharPassword  )
        this.setState({
            ...this.state,
            errors:{
                ...this.state.errors,
                password:isNot?Error:""
            }
        })
      }
    render() {
        const {email, Orgnr,password,errors} = this.state
        let {Token}  = this.props.match.params;
        let user = jwtDecode(Token)
        //console.log(jwtDecode(Token))
        return (
            <div className="d-flex justify-content-center align-items-center w-100 bg">
                 <div className="app-login-container animated slideInUpTiny animation-duration-3">
                    <div className="app-login-main-content">
                        <div className="app-logo-content d-flex align-items-center justify-content-center">
                            <Link className="logo-lg" to="/" title="Notyfile">
                                <img src={require("assets/images/logo.png")} alt="Notyfile" title="Notyfile"/>
                            </Link>
                        </div>
                        <div className="app-login-content">
                            <div className="app-login-header mb-4">
                                <h1><IntlMessages id="Account.New.Password.Get" /></h1>
                            </div> 
                            <div className="app-login-form">
                            {
                                (isEmpty(Token) || isUndefined(Token) )?
                                <>
                                <Alert severity={"warning"}>
                                <IntlMessages id="Account.New.Password.Error" />    
                                </Alert>
                                <div className="mb-3 d-flex align-items-center justify-content-between">
                                <Link to="/signin"><IntlMessages id="Log.in" /></Link>
                                </div>
                                </>
                                :
                                isEmpty(this.props.updateMessage)?
                                <form> 
<fieldset>

<TextField
label={<IntlMessages id="E-mail" /> }
fullWidth
onChange={(event) => this.setState({
    email: event.target.value,
    errors:[]
})}
defaultValue={email}
error ={errors.email?true:false}
helperText= {errors.email}
margin="normal"
className="mt-1 my-sm-3"
variant="outlined"
/>
<TextField
type="password"
label={ <IntlMessages id="PassWord" /> }
fullWidth
onChange={(event) => this.setState({password: event.target.value,errors:[]})}
defaultValue={password}
error = {errors.password?true:false}
helperText= {errors.password}
onKeyPress={this.handleKeyPress}
onBlur={this.CheckPassword}
margin="normal"
className="mt-1 my-sm-3"
variant="outlined"
/>
<div className="mb-3 d-flex align-items-center justify-content-between">
    <Button
    onClick={() => {
        if(this.isValid()){
            this.setState({ errors: {}, isLoading: true });
            this.props.userUpdatePasswrd({email, Orgnr,password,Token});                        
        }
        }} variant="contained" color="primary">
          <IntlMessages id="Account.New.Password.Save" />  
    </Button>
    <Link to="/signin">
    <IntlMessages id="Log.in" />
    </Link>
    </div>
</fieldset>

                                </form>
                                :
                                <>
<Alert severity={
    this.props.updateMessage.success?"info":"warning"
}>{this.props.updateMessage.success?this.props.updateMessage.message:this.props.updateMessage.error}</Alert>
<div className="mb-3 d-flex align-items-center justify-content-between">
<Link to="/signin"><IntlMessages id="Log.in" /></Link>
</div>
                                    </>
                            }
                            </div>
                        </div>
                    </div>  <InfoView/>
                 </div>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)(NyttPassword);